import { FormControl, FormHelperText, Grid, TextField } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useAsyncAction } from 'app/services';
import { reportTypeLoad } from 'app/store/report';
import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { Controller, useForm } from 'react-hook-form';
const UserReportForm = forwardRef((props, ref) => {
    const { asyncAction: fetchTypeData } = useAsyncAction(reportTypeLoad);
    const { onSubmit } = props;
    const { control, watch, register, formState, setValue, handleSubmit } = useForm({
        defaultValues: {
            from: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            to: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        },
    });
    const fromWatch = watch('from');
    const handleChangeFromDatetime = (newValue) => {
        setValue('from', moment(newValue).format('YYYY-MM-DD HH:mm:ss'));
    };
    const handleChangeToDatetime = (newValue) => {
        setValue('to', moment(newValue).format('YYYY-MM-DD HH:mm:ss'));
    };
    useImperativeHandle(ref, () => ({
        handleFormSubmit: () => {
            handleSubmit((data) => onSubmit({
                from: data.from,
                to: data.to,
                type_id: 4,
            }))();
        },
    }));
    useEffect(() => {
        fetchTypeData();
    }, []);
    return (React.createElement("form", null,
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(LocalizationProvider, { dateAdapter: AdapterMoment, adapterLocale: moment.locale('ru') },
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(FormControl, { error: !!formState.errors.from, margin: 'normal', variant: 'outlined', fullWidth: true },
                        React.createElement(Controller, { name: 'from', control: control, render: ({ field }) => (React.createElement(DesktopDatePicker, { label: '\u041D\u0430\u0447\u0430\u043B\u043E', views: ['day'], minDate: moment().subtract(33, 'days'), maxDate: moment(), inputFormat: 'DD.MM.YYYY HH:mm:ss', value: field.value, onChange: handleChangeFromDatetime, renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { sx: {
                                        svg: {
                                            fontSize: '20px',
                                        },
                                    } }, register(field.name, {
                                    required: true,
                                })))) })) }),
                        React.createElement(FormHelperText, null, "\u041D\u0430\u0447\u0430\u043B\u043E \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430"))),
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(FormControl, { error: !!formState.errors.to, margin: 'normal', variant: 'outlined', fullWidth: true },
                        React.createElement(Controller, { name: 'to', control: control, render: ({ field }) => (React.createElement(DesktopDatePicker, { label: '\u041A\u043E\u043D\u0435\u0446', views: ['day'], minDate: fromWatch, maxDate: moment(), inputFormat: 'DD.MM.YYYY HH:mm:ss', value: field.value, onChange: handleChangeToDatetime, renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { sx: {
                                        svg: {
                                            fontSize: '20px',
                                        },
                                    } }, register(field.name, {
                                    required: true,
                                })))) })) }),
                        React.createElement(FormHelperText, null, "\u041A\u043E\u043D\u0435\u0446 \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430")))))));
});
export default UserReportForm;
